import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
  const {minHeight:space} = theme.mixins.toolbar;
  const rez = {
    map: {
      position: "absolute",
      // right:0,
      // width: 'calc(100vw - 244px)',
      // width:props=>`calc(100vw -${props.paletteWidth}px)`,
      // width:'100%',
      height: `calc(100vh - ${space + 12}px)`,
      top:`${space + 12}px`,
      // height:'100vh',
      "&>.mapContainer":{
        position: "absolute",
        right:0,
        height: `calc(100vh - ${space}px)`,
        width:'100%'
      }
    },
  }
  return rez
});

export default useStyles;
